export default "__VITE_ASSET__26fe0758__"